import {Avatar} from '@dropbox/dig-components/avatar';
import {Text} from '@dropbox/dig-components/typography';
import {
  getDropboxerFullName,
  getDropboxerInitials,
} from 'components/manager_feedback/dropboxer_name_utils';
import {Dropboxer} from 'store/features/feedback_chat/types';

import styles from './dropboxer_card.module.css';

export const DropboxerCard = ({
  dropboxer,
  provider_title,
  provider_level,
}: {
  dropboxer: Dropboxer;
  provider_title: string;
  provider_level: string;
}) => (
  <div className={styles['label-group']}>
    <Avatar hasNoOutline className={styles['label-avatar']}>
      {getDropboxerInitials(dropboxer)}
    </Avatar>
    <div className={styles['label-text']}>
      <Text variant="label" tagName="span">
        {getDropboxerFullName(dropboxer)}
        <br />
      </Text>
      <Text variant="label" tagName="span" color="faint">
        {provider_title !== 'N/A' && provider_level !== 'N/A'
          ? `${provider_title} - ${provider_level}`
          : `${dropboxer.job_title} - ${dropboxer.job_level}`}
      </Text>
    </div>
  </div>
);
